import { Open_Commerce_User_Status } from '@occc/graphql';

export const userStatusMap: Record<Open_Commerce_User_Status, string> = {
  [Open_Commerce_User_Status.Enabled]: 'Enabled',
  [Open_Commerce_User_Status.Disabled]: 'Disabled',
  [Open_Commerce_User_Status.WaitingForValidation]: 'Waiting For Validation',
};
